import React from "react";
import { AppRoutes } from "./routes/Routes";
import { AuthProvider } from "./providers/AuthProvider";
import useWarmup from "./hooks/useWarmup";
import Warmup from "./components/Warmup";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";

function App() {
  const { phase } = useWarmup();

  if (phase === "ready") {
    return (
      <GlobalErrorBoundary>
        <div
          style={{
            animation: "v-fade-in 400ms ease-out both",
          }}
        >
          <style>{`
            @keyframes v-fade-in {
              from { opacity: 0; }
              to { opacity: 1; }
            }
          `}</style>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </div>
      </GlobalErrorBoundary>
    );
  }

  return <Warmup phase={phase} />;
}

export default App;
